import { createAction, props } from '@ngrx/store'

export const start_login = createAction('start_login', props<{ email: string; password: string }>())

export const start_login_with_otp = createAction('start_login_with_otp', props<{ email: string; otp: string }>())

export const login_success = createAction('login_success', props<{ bearer_token: string }>())

export const login_failed = createAction('login_failed', props<{ bearer_token: string }>())

export const start_sso_login = createAction('start_sso_login', props<{ id_token: string; companyDomain: string }>())

export const start_forgot_password = createAction(
  'start_forgot_password',
  props<{ email: string; callback: Function }>()
)

export const forgot_password_success = createAction('forgot_password_success', props<{ callback: Function }>())

export const forgot_password_failed = createAction('forgot_password_failed', props<{ error: string }>())

export const start_reset_password_with_password = createAction(
  'start_reset_password_with_password',
  props<{ oldPassword: string; newPassword: string; callback: Function }>()
)

export const reset_password_with_password_success = createAction(
  'reset_password_with_password_success',
  props<{ callback: Function }>()
)

export const reset_password_with_password_failed = createAction(
  'reset_password_with_password_failed',
  props<{ error: string }>()
)
